import React, { useReducer, useEffect } from 'react';
import { AppDispatchContext, AppStateContext } from '../contexts';
import { appStore as initalstate } from '../../store';
import { appReducer as reducer } from '../../services/reducers';
import { access } from '../../constants/roleDetails'
import { Redirect, useLocation } from 'react-router-dom';

const AppHoc = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initalstate)
  const location = useLocation()
  const sessionRole = sessionStorage.getItem('role')
  const role = sessionRole && sessionRole.toLowerCase().replace(/ /g, '_')

  useEffect(() => {
    dispatch({ companyId: parseInt(sessionStorage.getItem('company_id'), 10) })
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  })

  const path = location.pathname === '/' ? '/overview/*' : location.pathname
  const haveAccessToPath = access[role]?.find(item => path.match(new RegExp(item)))
  if(!haveAccessToPath) return <Redirect to='/forbidden' />

  return (
    <AppDispatchContext.Provider value={dispatch}>
      <AppStateContext.Provider value={state}>{children}</AppStateContext.Provider>
    </AppDispatchContext.Provider>
  );
};

export default AppHoc;
